export const getfilterFinancingTypeProduct = state => state.financingTypeProduct.filter
